'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeInput = exports.TimePicker = exports.Calendar = exports.DateInput = exports.ClockInput = exports.Clock = exports.Footer = exports.NavBar = exports.MultiMonthView = exports.TransitionView = exports.DateFormatSpinnerInput = exports.DateFormatInput = exports.MonthDecadeView = exports.DecadeView = exports.YearView = exports.MonthView = exports.DateEditor = undefined;

var _MonthView = require('./src/MonthView');

var _MonthView2 = _interopRequireDefault(_MonthView);

var _TimePicker = require('./src/TimePicker');

var _TimePicker2 = _interopRequireDefault(_TimePicker);

var _TimeInput = require('./src/TimeInput');

var _TimeInput2 = _interopRequireDefault(_TimeInput);

var _TransitionView = require('./src/TransitionView');

var _TransitionView2 = _interopRequireDefault(_TransitionView);

var _MultiMonthView = require('./src/MultiMonthView');

var _MultiMonthView2 = _interopRequireDefault(_MultiMonthView);

var _MonthDecadeView = require('./src/MonthDecadeView');

var _MonthDecadeView2 = _interopRequireDefault(_MonthDecadeView);

var _YearView = require('./src/YearView');

var _YearView2 = _interopRequireDefault(_YearView);

var _DecadeView = require('./src/DecadeView');

var _DecadeView2 = _interopRequireDefault(_DecadeView);

var _NavBar = require('./src/NavBar');

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Footer = require('./src/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _Clock = require('./src/Clock');

var _Clock2 = _interopRequireDefault(_Clock);

var _ClockInput = require('./src/ClockInput');

var _ClockInput2 = _interopRequireDefault(_ClockInput);

var _DateInput = require('./src/DateInput');

var _DateInput2 = _interopRequireDefault(_DateInput);

var _Calendar = require('./src/Calendar');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _DateFormatInput = require('./src/DateFormatInput');

var _DateFormatInput2 = _interopRequireDefault(_DateFormatInput);

var _DateFormatSpinnerInput = require('./src/DateFormatSpinnerInput');

var _DateFormatSpinnerInput2 = _interopRequireDefault(_DateFormatSpinnerInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

exports.default = _Calendar2.default;

// allow people to import with other aliases as well

var DateEditor = exports.DateEditor = _DateInput2.default;

exports.MonthView = _MonthView2.default;
exports.YearView = _YearView2.default;
exports.DecadeView = _DecadeView2.default;
exports.MonthDecadeView = _MonthDecadeView2.default;
exports.DateFormatInput = _DateFormatInput2.default;
exports.DateFormatSpinnerInput = _DateFormatSpinnerInput2.default;
exports.TransitionView = _TransitionView2.default;
exports.MultiMonthView = _MultiMonthView2.default;
exports.NavBar = _NavBar2.default;
exports.Footer = _Footer2.default;
exports.Clock = _Clock2.default;
exports.ClockInput = _ClockInput2.default;
exports.DateInput = _DateInput2.default;
exports.Calendar = _Calendar2.default;
exports.TimePicker = _TimePicker2.default;
exports.TimeInput = _TimeInput2.default;
